import React, { useEffect, useState } from "react";
import API from "../services/api.auth";
import { resolveImageSrc } from "../utils/imageUrl";

function WebListImage({ name, url }) {
  const initial = (name && name.trim()[0]) || "?";
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [url]);

  if (url && !broken) {
    return (
      <img
        className="weblist-img"
        src={url}
        alt={name}
        loading="lazy"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span className="weblist-fallback is-visible" aria-hidden>
      {initial.toUpperCase()}
    </span>
  );
}

function Home() {
  const [webList, setWebList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWebLists = async () => {
      setError("");
      setLoading(true);
      try {
        const res = await API.get("/webList");
        setWebList(res.data);
      } catch (err) {
        const message =
          err?.response?.data?.message ||
          (typeof err?.response?.data === "string" ? err.response.data : "") ||
          err?.message ||
          "Failed to load weblists";
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchWebLists();
  }, []);

  useEffect(() => {
    document.title = "Free Credit - Home";
  }, []);

  return (
    <>
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="d-flex align-items-center gap-2 text-secondary py-5 justify-content-center">
          <div
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          />
          <span>Loading weblists...</span>
        </div>
      ) : webList.length === 0 ? (
        <div className="card shadow-sm">
          <div className="card-body text-center py-5">
            <p className="text-secondary mb-3">
              Opps Something Went Wrong... 😭
            </p>
          </div>
        </div>
      ) : (
        <>
          <div className="div-header-container m-3">
            <p className="div-header-container-title">
              Free Credit - Malaysia's Trusted Free Credit No Deposit Guide (
              {new Date().getFullYear()})
            </p>
            <p className="div-header-container-content">
              We don't encourage gambling. We provide{" "}
              <strong>accurate, transparent, and updated information</strong> on
              Heylink free credit offers and partnerships from Malaysia's most
              trusted companies.
            </p>
          </div>
          <div className="row g-3 m-2">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/94c01878fd6864692c8d7.jpg"
                    alt="Puma777-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    Puma777
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://puma777.me/RFA07000752"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-0 btn-md"
                  >
                    👉👉 Claim RM25 Free Register Credit
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/0db6cfe091996dd7f4eec.webp"
                    alt="Cili88-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    Cili88
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://cili88.me/RFA07001A9A"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-2 btn-md"
                  >
                    👉👉 Claim Welcome Bonus 180% !!
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/6d7985408b6867cb66c10.png"
                    alt="Hijau 44-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    Hijau44
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://hijau44.me/RFA0700A170"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-3 btn-md"
                  >
                    👉👉 Claim New Register RM30
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-3 m-2">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/274ac8fcc17966df9840d.webp"
                    alt="MegaBoi-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    Megaboi
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://megaboi.club/RFA06996331"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-1 btn-md"
                  >
                    👉👉 Claim RM6 Free Credit
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/61ecc4ae79c7616f9a670.png"
                    alt="DapatCuci-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    DapatCuci
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://dapatcuci.co/RFA06997890"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-2 btn-md"
                  >
                    👉👉 Claim RM88 From All Games
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-sm text-center">
                {/* Image container */}
                <div className="card-img-top position-relative">
                  <img
                    className="weblist-img"
                    loading="lazy"
                    src="https://xt30sf.b-cdn.net/media/be0a49bc90996b499c051.gif"
                    alt="iSenang88-Jom Free Credit Malaysia"
                    width="100"
                    height="100"
                  />
                  {/* Bottom-right badge */}
                  <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                    iSenang88
                  </span>
                </div>

                {/* Name */}
                <div className="card-body">
                  <a
                    href="https://isenang88.com/RFA0699882A"
                    target="_blank"
                    rel="noopener noreferrer sponsored"
                    className="btn btn-manual-3 btn-md"
                  >
                    👉👉 Claim Free Credit 365 Days
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="div-game-gif-img-1">
            <a
              href="https://iduit88b.com/RFA0781A875"
              target="_blank"
              rel="noopener noreferrer sponsored"
            >
              <img
                className="game-gif-img-1"
                loading="lazy"
                src="https://xt30sf.b-cdn.net/media/0f17617a438967e2d7850.gif"
                alt="GameGif-Jom Free Credit Malaysia"
              />
            </a>
          </div>
          <p className="section-1">🎰🤑⬇️SCRPLAY/VAG888⬇️🤑🎰</p>
          <div className="row g-3 m-2">
            {webList.map((webL) => {
              const photoSrc = resolveImageSrc(webL, { cacheBust: true });

              return (
                <div key={webL.id} className="col-6 col-md-6 col-lg-4">
                  <div className="card h-100 shadow-sm text-center">
                    {/* Image container */}
                    <div className="card-img-top position-relative">
                      <WebListImage
                        name={webL.name}
                        url={photoSrc}
                        alt="Jom Free Credit Malaysia"
                      />

                      {/* Bottom-right badge */}
                      <span className="badge bg-custom position-absolute bottom-0 end-0 m-2">
                        {webL.name}
                      </span>
                    </div>

                    <p className="card-text mb-0 mt-2">{webL.introtext}</p>

                    {/* Name */}
                    <div className="card-body p-2">
                      {webL.link1url && webL.link1name && (
                        <a
                          href={webL.link1url}
                          target="_blank"
                          rel="noopener noreferrer sponsored"
                          className="btn btn-gradient btn-md"
                        >
                          {webL.link1name}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
}

export default Home;
